export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={`animate-pulse bg-surface-3 rounded ${className ?? 'w-16 h-4'}`}
      aria-hidden="true"
    />
  );
}

interface TableSkeletonProps {
  columns: number;
  rows?: number;
}

export function TableSkeleton({ columns, rows = 5 }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <tr key={i} className="border-b border-surface-3 last:border-0">
          {Array.from({ length: columns }, (_, j) => (
            <td key={j} className="table-cell">
              <Skeleton className={`h-4 ${j === 0 ? 'w-16' : j === columns - 1 ? 'w-24' : 'w-20'}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
